import clsx from 'clsx';
import { createElement, forwardRef } from 'react';
import { atoms } from '../../css/atoms/atoms';
import { sprinkles } from '../../css/atoms/sprinkles.css';
import { useDataAttributes } from '../../hooks/useDataAttributes';
export const boxPaddingNames = [
    'padding',
    'paddingX',
    'paddingY',
    'paddingTop',
    'paddingBottom',
    'paddingLeft',
    'paddingRight',
];
export const boxMarginNames = [
    'margin',
    'marginX',
    'marginY',
    'marginTop',
    'marginBottom',
    'marginLeft',
    'marginRight',
];
export const Box = forwardRef(({ component = 'div', className, dataAttributes, dataTest, ...props }, ref) => {
    const atomProps = {};
    const nativeProps = {};
    for (const key in props) {
        if (sprinkles.properties.has(key)) {
            atomProps[key] = props[key];
        }
        else {
            nativeProps[key] = props[key];
        }
    }
    const atomicClasses = atoms({
        reset: typeof component === 'string' ? component : 'div',
        ...atomProps,
    });
    const combinedClasses = clsx(atomicClasses, className);
    return createElement(component, {
        className: combinedClasses.length === 0 ? undefined : combinedClasses.trim(),
        ...nativeProps,
        ...useDataAttributes(dataAttributes, dataTest),
        ref,
    });
});
